import { render, staticRenderFns } from "./TaskCardDescription.vue?vue&type=template&id=14f55494&"
import script from "./TaskCardDescription.vue?vue&type=script&lang=js&"
export * from "./TaskCardDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports